import React from 'react'
import User from './User'
import Loader from '../Loader/Loader'
import FiveHundred from '../Page/Error/FiveHundred'
import {ajaxGet} from 'api/explus-api'

class UserContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: '',
      children: '',
      loaded: false,
      error: false
    }
  }

  componentDidMount() {
    this.getUser()
  }

  getUser() {
    return ajaxGet('web/partners').then(data => {
      if (data.status !== undefined || data.status === 'error') { 
        this.setState({error: true})
      } else {
        this.setState({error: false})
        this.setState({user: data})  
      }

      this.setState({loaded: true})
    })
  }

  displayContent() {
    let body = <Loader/>

    if (this.state.loaded) {
      if (this.state.error) {
        body = <FiveHundred/>
      } else {
        body = <User user={this.state.user}/>
      }
    }

    return body
  }

  render() {
    return (
      <div className="page-user">
        {this.displayContent()}
      </div>
    )
  }
}

export default UserContainer
